export default __webpack_public_path__ + "static/media/kita.4ec34523.svg";